import { render } from "./ConfirmDialog.vue?vue&type=template&id=2e9015d8&scoped=true"
import script from "./ConfirmDialog.vue?vue&type=script&lang=ts"
export * from "./ConfirmDialog.vue?vue&type=script&lang=ts"

import "./ConfirmDialog.vue?vue&type=style&index=0&id=2e9015d8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2e9015d8"

export default script